import { A } from './format';
import { TOTAL_COST_MONTHS } from './constants';

// Cost arrays are TOTAL_COST_MONTHS long (72 slots)
// Array index 36 = forecast month 0; index 0 = 36 months before forecast
const AC = (v = '') => Array(TOTAL_COST_MONTHS).fill(null).map(() => v);

export function defaultPlatformState() {
  return {
    enabled: false,
    rrpEA: '', rrpFL: '',
    launchEA: '', launchFL: '',
    method: 'manual',
    units: A(),
    regionalPct: A('0'), discountPct: A('0'), daysDiscount: A(''),
    platformDeal: A('0'), resellers: A('0'), physical: A('0'), otherDeal: A('0'),
    pricingMode: 'rrp',
    dlcs: '[]',
    customRow1Label: 'Custom Row 1', customRow1: A('0'),
    customRow2Label: 'Custom Row 2', customRow2: A('0'),
  };
}

export function defaultCostState() {
  return {
    recoup: {
      devAdvances: AC(), loc: AC(), qa: AC(), otherPub: AC(), marketing: AC(),
    },
    nonRecoup: {
      devAdvances: AC(), loc: AC(), qa: AC(), otherPub: AC(), marketing: AC(),
    },
  };
}

export function defaultDealTerms() {
  return {
    devAdvanceCurrency: 'USD',
    devAdvanceAmt: '',
    pubCostsBudget: '',
    marketingBudget: '',
    royaltyPreRecoup: '',
    royaltyPostRecoup: '',
  };
}

export function getPlatformState(PS, game, platKey) {
  if (!PS) return defaultPlatformState();
  if (!PS[game]) PS[game] = {};
  if (!PS[game][platKey]) PS[game][platKey] = defaultPlatformState();
  // Migrate: add any missing fields from default
  const st = PS[game][platKey];
  const def = defaultPlatformState();
  Object.keys(def).forEach(k => {
    if (st[k] === undefined) st[k] = def[k];
  });
  return st;
}

export function getCostState(CS, game) {
  if (!CS) return defaultCostState();
  if (!CS[game]) CS[game] = {};
  if (!CS[game]['__game__']) CS[game]['__game__'] = defaultCostState();
  // Migrate old 36-slot arrays to 72-slot if needed
  const costs = CS[game]['__game__'];
  ['recoup','nonRecoup'].forEach(sec => {
    Object.keys(costs[sec]).forEach(f => {
      if (costs[sec][f].length === 36) {
        // Old format — pad with 36 empty slots at the start
        costs[sec][f] = Array(36).fill('').concat(costs[sec][f]);
      }
    });
  });
  return costs;
}

export function getDealTerms(DT, game) {
  if (!DT) return defaultDealTerms();
  if (!DT[game]) DT[game] = defaultDealTerms();
  return DT[game];
}
